import { createStore } from 'zustand';
import { AnalyticsViewSource } from '@inter-ikea-storageone/shared/analytics';
import type { DesignState, DesignStateData } from './types';

const getInitialDesignStateData = (): DesignStateData => ({
  cantOpenDesignModal: false,
  loadVpcSheetVisible: false,
  loadVpcSheetVisibleOnExit: false,
  openDesign: {
    visible: false,
    currentPosition: AnalyticsViewSource.hamburgerMenu,
    showSavedDesignsTab: false
  },
  openDesignActiveTab: 'ikeaProfile',
  openDesignSheetVisibleOnExit: false,
  saveAsDesignToProfile: false,
  saveDesignToProfile: false,
  saveVpcSheetBack: false,
  saveVpcSheetOpenedFromPrint: false,
  saveVpcSheetVisible: false,
  shareDesignCard: false
});

export const designStore = createStore<DesignState>(set => ({
  ...getInitialDesignStateData(),
  actions: {
    resetDesignState: () => {
      set(getInitialDesignStateData());
    },
    setLoadVpcSheetVisible: visible => {
      set({ loadVpcSheetVisible: visible });
    },
    setLoadVpcSheetVisibleOnExit: visible => {
      set({ loadVpcSheetVisibleOnExit: visible });
    },
    showSaveVpcSheet: back => {
      set({ saveVpcSheetVisible: true, saveVpcSheetBack: back });
    },
    hideSaveVpcSheet: () => {
      set({ saveVpcSheetVisible: false });
    },
    setSaveVpcSheetOpenedFromPrint: openedFromPrint => {
      set({ saveVpcSheetOpenedFromPrint: openedFromPrint });
    },
    showCantOpenDesignModal: () => {
      set({ cantOpenDesignModal: true });
    },
    hideCantOpenDesignModal: () => {
      set({ cantOpenDesignModal: false });
    },
    showSaveDesignToProfileSheet: () => {
      set({ saveDesignToProfile: true });
    },
    hideSaveDesignToProfileSheet: () => {
      set({ saveDesignToProfile: false });
    },
    showSaveAsDesignToProfileSheet: () => {
      set({ saveAsDesignToProfile: true });
    },
    hideSaveAsDesignToProfileSheet: () => {
      set({ saveAsDesignToProfile: false });
    },
    showShareDesignCard: () => {
      set({ shareDesignCard: true });
    },
    hideShareDesignCard: () => {
      set({ shareDesignCard: false });
    },
    showOpenDesignSheet: payload => {
      set({
        openDesign: {
          visible: true,
          currentPosition: payload.currentPosition,
          showSavedDesignsTab: payload.showSavedDesignsTab
        }
      });
    },
    hideOpenDesignSheet: payload => {
      set({
        openDesign: {
          visible: false,
          currentPosition: payload.currentPosition,
          showSavedDesignsTab: false
        }
      });
    },
    setOpenDesignActiveTab: activeTab => {
      set({ openDesignActiveTab: activeTab });
    },
    setOpenDesignSheetVisibleOnExit: visible => {
      set({ openDesignSheetVisibleOnExit: visible });
    }
  }
}));
